module.exports = __webpack_public_path__ + "static/media/cins_2023_frontcover.2ab4111b.png";